import { useAppDispatch, useAppSelector } from "../../app";
import { useCallback } from "react";
import { ICategorization } from "../../configMap/interfaces/category";
import {
  modifyCategorizationAnnotationsByGroupBlockIndexInState,
  removeCategorizationAnnotationsByCategorizationsInState,
  resetCategorizationAnnotationsInState,
  updateGroupBlockCategorizationAnnotationsInState,
} from "../store/metadataSlice";

const useCategorizationAnnotations = () => {
  const categorizationAnnotations = useAppSelector(
    (state) =>
      state.metadataReducer.categorizationState.categorizationAnnotations,
  );

  const dispatch = useAppDispatch();

  const modifyCategorizationAnnotations = useCallback(
    (
      categorizations: Array<ICategorization>,
      groupBlockIndex: number,
      isGroupBlockRemoved: boolean,
      documentId?: string,
    ) => {
      if (!documentId || !categorizationAnnotations?.length) {
        return;
      }

      dispatch(
        modifyCategorizationAnnotationsByGroupBlockIndexInState({
          documentId,
          categorizations,
          groupBlockIndex,
          isGroupBlockRemoved,
        }),
      );
    },
    [categorizationAnnotations, dispatch],
  );

  const removeCategorizationAnnotationsByCategorizations = useCallback(
    (categorizations: Array<ICategorization>, documentId?: string) => {
      if (!documentId || !categorizationAnnotations?.length) {
        return;
      }

      dispatch(
        removeCategorizationAnnotationsByCategorizationsInState({
          documentId,
          categorizations,
        }),
      );
    },
    [categorizationAnnotations, dispatch],
  );

  const updateGroupBlockCategorizationAnnotations = useCallback(
    (
      categorizations: Array<ICategorization>,
      groupBlockIndex: number,
      addBefore: boolean = false,
    ) => {
      if (!categorizationAnnotations?.length) {
        return;
      }

      dispatch(
        updateGroupBlockCategorizationAnnotationsInState({
          categorizations,
          groupBlockIndex,
          addBefore,
        }),
      );
    },
    [categorizationAnnotations, dispatch],
  );

  const resetCategorizationAnnotations = useCallback(() => {
    dispatch(resetCategorizationAnnotationsInState());
  }, [dispatch]);

  return {
    modifyCategorizationAnnotations,
    removeCategorizationAnnotationsByCategorizations,
    updateGroupBlockCategorizationAnnotations,
    resetCategorizationAnnotations,
  };
};

export default useCategorizationAnnotations;
